export const SET_PPT_JSON = 'SET_PPT_JSON';
export const GENERATE_PPT_REQUEST = 'GENERATE_PPT_REQUEST';
export const GENERATE_PPT_SUCCESS = 'GENERATE_PPT_SUCCESS';
